<script setup>
import { __, decodeHTMLEntities } from '@/utils';
import { ErrorMessage, useField } from 'vee-validate';
import { ref, computed, watch } from 'vue';
import {
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
} from '@headlessui/vue';
import Loader from '@components/loader.vue';
import debounce from 'lodash/debounce';
import { useDisableCityField } from '@composables/useDisableCityField';

const props = defineProps(['name', 'type', 'label', 'city_code', 'disabled', 'isShipping']);
const emit = defineEmits(['selected']);

const { handleChange: handleFieldChange, value } = useField(props.name);
const loading = ref(false);
const streets = ref([]);
const query = ref('');
const currentValue = ref({
    name: value || ''
});

const getCityStreets = async (city_code, street_name = '') => {
    let response = [];
    loading.value = true;

    const streetData = {
		'city_code': city_code,
        'street_name': street_name,
	};

	const streetDataJsonString = JSON.stringify(streetData);

    try {
        response = await fetch(ajax_object.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `action=get_streets&street_data=${streetDataJsonString}`,
        })
            .then(response => response.json())
            .then(data => {
                const apiResponse = JSON.parse(data.data);
                if (apiResponse.response?.status == false) {
                    return [];
                } else {
                    return apiResponse.response.map(item => ({
                        ...item,
                        name: decodeHTMLEntities(item.name),
                    }));
                }
            })
            
        loading.value = false;
    } catch (error) {
        console.log(error)
    }

    return response;
};

const filteredStreets = computed(() =>
    query.value.length < 1
        ? []
        : streets.value.filter((street) => {
            return street.name.toLowerCase().includes(query.value.toLowerCase());
        })
);

const handleChange = debounce(async (event) => {
    const value = event.target.value;
    query.value = value;
    handleFieldChange(value);
    if(value.length > 1) {
        streets.value = await getCityStreets(props.city_code, value) || [];
    }
}, 300);

const handleTrimValue = (event) => {
    const value = event.target.value.trimStart();
    event.target.value = value;
};

watch(currentValue, (value) => {
    emit('selected', value);
    handleFieldChange(value.name)
});

const { disableCityField } = useDisableCityField(props.type);
</script>
<template>
    <div class="field">
        <ErrorMessage :name="name" as="span" class="field__error" />
        <ErrorMessage :name="`${type}StreetCode`" as="span" class="field__error" v-if="name === 'subscriberShippingStreet' || name === 'companyShippingStreet'" />

        <label :for="name">
            {{ label }}
        </label><!-- /.form__label -->

        <div class="combobox-outer">
            <!-- <Combobox v-model="currentValue" :disabled="!city_code || disableStreetField"> -->
            <Combobox v-model="currentValue" :disabled="disableCityField && !isShipping || disabled">
                <div class="combobox-wrapper">
                    <ComboboxInput
                        @input="handleTrimValue"
                        @change="handleChange"
                        :displayValue="(item) => item.name"
                        :id="name"
                        :name="name"
                    />
                    <Loader class="align-end combobox-loader" color="#2563eb" v-if="loading" />
                </div>
                <ComboboxOptions class="combobox-options">
                    <ComboboxOption
                        v-for="street in filteredStreets"
                        :key="street.code"
                        :value="street"
                        class="combobox-option combobox-option--smaller"
                    >
                        {{ street.name }}
                    </ComboboxOption>
                </ComboboxOptions>
            </Combobox>
        </div>
    </div><!-- /.field -->
</template>